import { render, staticRenderFns } from "./PreAuthLayout.vue?vue&type=template&id=3be8c20b&"
import script from "./PreAuthLayout.vue?vue&type=script&lang=js&"
export * from "./PreAuthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports